<template>
  <v-dialog
      v-model="dialogInterno"
      :max-width="isMobile ? '100vw' : '1000px'"
      persistent
      :fullscreen="isMobile"
  >
    <v-card class="d-flex flex-column" style="height: 100vh;">
      <!-- Cabeçalho -->
      <v-card-title class="dialog-header flex-shrink-0" :class="isMobile ? 'pa-3' : 'pa-4'">
        <div class="d-flex align-center flex-grow-1" style="min-width: 0;">
          <div class="icon-wrapper-small mr-2">
            <v-icon color="white" :size="isMobile ? 20 : 24">
              {{ modoEdicao ? 'mdi-pencil' : 'mdi-plus' }}
            </v-icon>
          </div>
          <div style="min-width: 0; flex: 1;">
            <div class="dialog-title text-truncate">
              {{ modoEdicao ? 'Editar Normativa' : 'Nova Normativa' }}
            </div>
            <div v-if="!isMobile" class="dialog-subtitle">
              {{ modoEdicao ? 'Atualize as informações da normativa' : 'Preencha os dados da nova normativa' }}
            </div>
          </div>
        </div>
        <v-btn
            icon
            @click="fechar"
            :disabled="salvando"
            color="white"
            :small="isMobile"
            class="ml-2 flex-shrink-0"
        >
          <v-icon :size="isMobile ? 20 : 24">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <!-- Conteúdo com Scroll -->
      <v-card-text class="dialog-content flex-grow-1" :class="isMobile ? 'pa-3' : 'pa-6'">
        <v-form ref="form" v-model="formularioValido" @submit.prevent="salvar">
          <!-- Seção: Dados Básicos -->
          <v-card outlined class="section-card mb-4">
            <v-card-title class="section-header" :class="isMobile ? 'pa-3' : 'pa-4'">
              <v-icon color="#023449" :size="isMobile ? 20 : 24" class="mr-2">mdi-information</v-icon>
              <span class="section-title">Dados Básicos</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text :class="isMobile ? 'pa-3' : 'pa-4'">
              <v-row :class="isMobile ? 'ma-0' : ''">
                <!-- Código -->
                <v-col cols="12" :sm="isMobile ? 12 : 3" :class="isMobile ? 'pa-2' : 'pb-0'">
                  <v-text-field
                      v-model="formulario.codigo"
                      label="Código"
                      placeholder="001"
                      outlined
                      dense
                      :rules="regras.codigo"
                      :disabled="salvando"
                      maxlength="3"
                      counter
                      required
                      hide-details="auto"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon small color="#64748b">mdi-numeric</v-icon>
                    </template>
                    <template v-if="!isMobile" v-slot:append-outer>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon small v-bind="attrs" v-on="on">mdi-information-slab-circle-outline</v-icon>
                        </template>
                        <span>O código deve ser o mesmo número informado no documento da normativa.</span>
                      </v-tooltip>
                    </template>
                  </v-text-field>
                  <div v-if="isMobile" class="text-caption grey--text mt-1">
                    O código deve ser o mesmo número informado no documento
                  </div>
                </v-col>

                <!-- Categorias -->
                <v-col cols="12" :sm="isMobile ? 12 : 9" :class="isMobile ? 'pa-2' : 'pb-0'">
                  <v-select
                      v-model="formulario.ids_categorias"
                      :items="categorias"
                      item-text="nome"
                      item-value="id"
                      label="Categorias"
                      placeholder="Selecione uma ou mais categorias"
                      outlined
                      dense
                      multiple
                      chips
                      small-chips
                      deletable-chips
                      :rules="regras.categorias"
                      :disabled="salvando"
                      :loading="carregandoCategorias"
                      required
                      hide-details="auto"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon small color="#64748b">mdi-shape</v-icon>
                    </template>

                    <template v-slot:selection="{ item, index }">
                      <CategoriaChip
                          v-if="index < (isMobile ? 2 : 3)"
                          :categoria="item"
                          size="x-small"
                          closeable
                          @click:close="removerCategoria(item.id)"
                          class="mr-1 mb-1"
                      />
                      <span
                          v-if="index === (isMobile ? 2 : 3)"
                          class="grey--text text-caption ml-1"
                      >
                        (+{{ formulario.ids_categorias.length - (isMobile ? 2 : 3) }})
                      </span>
                    </template>

                    <template v-slot:item="{ item }">
                      <CategoriaChip
                          :categoria="item"
                          size="small"
                          class="my-1"
                      />
                    </template>

                    <template v-if="!isMobile" v-slot:append-outer>
                      <v-tooltip bottom max-width="300">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on" small color="#64748b">
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span>
                          Selecione de 1 a 5 categorias para classificar esta normativa.
                          Categorias ajudam na organização e busca de documentos.
                        </span>
                      </v-tooltip>
                    </template>
                  </v-select>

                  <div v-if="formulario.ids_categorias.length > 0" class="mt-2">
                    <v-chip
                        x-small
                        :color="categoriasSelecionadasValidas ? '#e8f5e9' : '#ffebee'"
                        :text-color="categoriasSelecionadasValidas ? '#2e7d32' : '#c62828'"
                    >
                      <v-icon left x-small :color="categoriasSelecionadasValidas ? '#2e7d32' : '#c62828'">
                        {{ categoriasSelecionadasValidas ? 'mdi-check-circle' : 'mdi-alert-circle' }}
                      </v-icon>
                      {{ formulario.ids_categorias.length }} de 5 categorias
                    </v-chip>
                  </div>
                </v-col>

                <!-- Título -->
                <v-col cols="12" :class="isMobile ? 'pa-2' : 'pb-0'">
                  <v-text-field
                      v-model="formulario.titulo"
                      label="Título da Normativa"
                      placeholder="Ex: Política de Segurança da Informação"
                      outlined
                      dense
                      :rules="regras.titulo"
                      :disabled="salvando"
                      maxlength="200"
                      counter
                      required
                      hide-details="auto"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon small color="#64748b">mdi-format-title</v-icon>
                    </template>
                  </v-text-field>
                </v-col>

                <!-- Descrição -->
                <v-col cols="12" :class="isMobile ? 'pa-2' : 'pb-0'">
                  <v-textarea
                      v-model="formulario.descricao"
                      label="Descrição (Opcional)"
                      placeholder="Descreva brevemente o conteúdo desta normativa..."
                      outlined
                      dense
                      :disabled="salvando"
                      maxlength="1000"
                      counter
                      :rows="isMobile ? 2 : 3"
                      auto-grow
                      hide-details="auto"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon small color="#64748b">mdi-text</v-icon>
                    </template>
                  </v-textarea>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- Seção: Arquivo Principal -->
          <v-card outlined class="section-card mb-4">
            <v-card-title class="section-header" :class="isMobile ? 'pa-3' : 'pa-4'">
              <v-icon color="#023449" :size="isMobile ? 20 : 24" class="mr-2">mdi-file-pdf-box</v-icon>
              <span class="section-title">Arquivo Principal</span>
              <v-chip x-small color="error" dark class="ml-2">Obrigatório</v-chip>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text :class="isMobile ? 'pa-3' : 'pa-4'">
              <v-row :class="isMobile ? 'ma-0' : ''">
                <v-col cols="12" :class="isMobile ? 'pa-2' : ''">
                  <FileUpload
                      v-model="arquivoPrincipal"
                      label="Upload do Arquivo Principal"
                      :tamanho-maximo-m-b="20"
                      :show-p-d-f-preview="!isMobile"
                      :disabled="salvando"
                      required
                      @change="handleArquivoPrincipalChange"
                  />
                </v-col>

                <v-col cols="12" :class="isMobile ? 'pa-2' : ''">
                  <v-text-field
                      v-model="formulario.arquivo_nome"
                      label="Nome do Arquivo"
                      placeholder="Ex: 001 Politica Seguranca.pdf"
                      outlined
                      dense
                      :rules="regras.arquivo_nome"
                      :disabled="salvando"
                      maxlength="255"
                      required
                      hide-details="auto"
                      @blur="normalizarNomeArquivo"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon small color="#64748b">mdi-file-document</v-icon>
                    </template>

                    <template v-if="!isMobile" v-slot:append-outer>
                      <v-tooltip bottom max-width="400">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on" small color="#64748b">
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div>
                          <strong>Nome do arquivo válido:</strong>
                          <ul class="mt-2 pl-4">
                            <li>Letras, números, espaços, hífen e underscore</li>
                            <li>Deve terminar com .pdf</li>
                            <li>Exemplos: "001 Normativa.pdf", "Politica RH.pdf"</li>
                          </ul>
                        </div>
                      </v-tooltip>
                    </template>
                  </v-text-field>

                  <div class="mt-2">
                    <v-chip x-small color="#e3f2fd" text-color="#1565c0">
                      <v-icon left x-small color="#1565c0">mdi-lightbulb-outline</v-icon>
                      <span :class="isMobile ? 'text-caption' : ''">
                        {{ isMobile ? 'Use letras, números e espaços' : 'Dica: Use letras, números, espaços (Ex: Politica de Seguranca 2024.pdf)' }}
                      </span>
                    </v-chip>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- Seção: Anexos -->
          <v-card outlined class="section-card mb-4">
            <v-card-title class="section-header" :class="isMobile ? 'pa-3' : 'pa-4'">
              <v-icon color="#023449" :size="isMobile ? 20 : 24" class="mr-2">mdi-paperclip</v-icon>
              <span class="section-title">Anexos</span>
              <v-spacer></v-spacer>
              <v-chip :x-small="isMobile" :small="!isMobile" color="#e8f5e9" text-color="#2e7d32">
                <v-icon left x-small color="#2e7d32">mdi-paperclip</v-icon>
                {{ formulario.anexos.length }}
              </v-chip>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text :class="isMobile ? 'pa-3' : 'pa-4'">
              <div v-if="formulario.anexos.length > 0" :class="isMobile ? 'mb-3' : 'mb-4'">
                <NormativaAnexoItem
                    v-for="(anexo, index) in formulario.anexos"
                    :key="index"
                    v-model="formulario.anexos[index]"
                    :index="index"
                    :disabled="salvando"
                    @remover="removerAnexo"
                    @atualizar-nome="atualizarNomeArquivoAnexo"
                    class="mb-3"
                />
              </div>

              <v-alert
                  v-else
                  type="info"
                  text
                  dense
                  :class="isMobile ? 'mb-3' : 'mb-4'"
              >
                <div class="d-flex align-center">
                  <span :class="isMobile ? 'text-caption' : ''">
                    {{ isMobile ? 'Nenhum anexo adicionado' : 'Nenhum anexo adicionado. Clique no botão abaixo para adicionar anexos complementares.' }}
                  </span>
                </div>
              </v-alert>

              <v-btn
                  outlined
                  color="#023449"
                  block
                  @click="adicionarAnexo"
                  :disabled="salvando"
                  :small="isMobile"
                  class="add-attachment-btn"
              >
                <v-icon left :small="isMobile">mdi-plus</v-icon>
                Adicionar Anexo
              </v-btn>
            </v-card-text>
          </v-card>

          <!-- Seção de Permissões -->
          <NormativaPermissoes
              ref="permissoes"
              v-model="permissoes"
              :disabled="salvando"
              :class="isMobile ? 'mb-3' : 'mb-5'"
              @erro="mostrarSnackbar($event, 'error')"
          />
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <!-- Ações -->
      <v-card-actions class="dialog-actions flex-shrink-0" :class="isMobile ? 'pa-3' : 'pa-4'">
        <v-btn
            text
            @click="fechar"
            :disabled="salvando"
            color="#64748b"
            :small="isMobile"
        >
          Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
            color="#023449"
            @click="salvar"
            :loading="salvando"
            :disabled="!podeEnviar || salvando"
            :small="isMobile"
            class="save-btn"
        >
          <v-icon left :small="isMobile">mdi-content-save</v-icon>
          {{ modoEdicao ? 'Atualizar' : 'Salvar' }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- Snackbar -->
    <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :timeout="3000"
        bottom
        :multi-line="isMobile"
    >
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn
            text
            v-bind="attrs"
            @click="snackbar.show = false"
            :small="isMobile"
        >
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import FileUpload from '../Widgets/FileUpload.vue'
import NormativaAnexoItem from './NormativaAnexoItem.vue'
import NormativaPermissoes from './NormativaPermissoes.vue'
import CategoriaChip from '../Widgets/CategoriaChip.vue'
import { mapState } from 'vuex'

export default {
  name: 'NormativaFormulario',

  components: {
    FileUpload,
    NormativaAnexoItem,
    CategoriaChip,
    NormativaPermissoes
  },

  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    normativa: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      dialogInterno: false,
      formularioValido: false,
      salvando: false,
      carregandoCategorias: false,
      windowWidth: window.innerWidth,

      categorias: [],
      arquivoPrincipal: null,

      formulario: {
        codigo: '',
        titulo: '',
        descricao: '',
        ids_categorias: [],
        arquivo_nome: '',
        arquivo_base64: '',
        publica: 'T',
        ids_grupos: [],
        ids_usuarios: [],
        anexos: []
      },

      permissoes: {
        publica: 'T',
        ids_grupos: [],
        ids_usuarios: []
      },

      regras: {
        codigo: [
          v => !!v || 'Código é obrigatório',
          v => (v && v.length <= 3) || 'Código deve ter no máximo 3 caracteres',
          v => (v && /^\d+$/.test(v)) || 'Código deve conter apenas números'
        ],
        titulo: [
          v => !!v || 'Título é obrigatório',
          v => (v && v.trim().length >= 3) || 'Título deve ter no mínimo 3 caracteres',
          v => (v && v.length <= 200) || 'Título deve ter no máximo 200 caracteres'
        ],
        categorias: [
          v => (v && v.length > 0) || 'Selecione pelo menos uma categoria',
          v => (v && v.length <= 5) || 'Máximo de 5 categorias'
        ],
        arquivo_nome: [
          v => !!v || 'Nome do arquivo é obrigatório',
          v => {
            if (!v) return true
            const nomeBase = v.replace(/\.pdf$/i, '')
            const regexValido = /^[a-zA-Z0-9\u00C0-\u00FF ,_-]+$/
            return regexValido.test(nomeBase) || 'Nome do arquivo contém caracteres inválidos'
          },
          v => (v && v.toLowerCase().endsWith('.pdf')) || 'Arquivo deve terminar com .pdf'
        ]
      },

      snackbar: {
        show: false,
        message: '',
        color: 'success'
      }
    }
  },

  computed: {
    ...mapState(["backendUrl"]),

    isMobile() {
      return this.windowWidth < 960
    },

    modoEdicao() {
      return !!(this.normativa && this.normativa.id)
    },

    categoriasSelecionadasValidas() {
      return this.formulario.ids_categorias.length >= 1 &&
          this.formulario.ids_categorias.length <= 5
    },

    podeEnviar() {
      const temArquivo = this.formulario.arquivo_base64 || (this.modoEdicao && this.normativa?.arquivo_base64)

      return this.formularioValido &&
          this.formulario.codigo &&
          this.formulario.titulo &&
          this.formulario.ids_categorias.length > 0 &&
          this.formulario.ids_categorias.length <= 5 &&
          this.formulario.arquivo_nome &&
          this.validarNomeArquivoPrincipal(this.formulario.arquivo_nome) &&
          temArquivo
    }
  },

  mounted() {
    window.addEventListener('resize', this.handleResize)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },

  watch: {
    dialog: {
      immediate: true,
      handler(val) {
        this.dialogInterno = val
        if (val) {
          this.inicializar()
        }
      }
    },

    dialogInterno(val) {
      if (!val) {
        this.$emit('update:dialog', false)
      }
    },

    permissoes: {
      deep: true,
      handler(val) {
        this.formulario.publica = val.publica
        this.formulario.ids_grupos = val.ids_grupos
        this.formulario.ids_usuarios = val.ids_usuarios
      }
    }
  },

  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth
    },

    async inicializar() {
      await this.carregarCategorias()
      this.carregarNormativa()
    },

    async carregarCategorias() {
      this.carregandoCategorias = true

      try {
        const response = await axios.post(`${this.backendUrl}normativa/categoria`, {
          acao: 'listar'
        })

        this.categorias = response.data || []

      } catch (error) {
        console.error('Erro ao carregar categorias:', error)
        this.mostrarSnackbar('Erro ao carregar categorias', 'error')
      } finally {
        this.carregandoCategorias = false
      }
    },

    carregarNormativa() {
      if (this.modoEdicao) {
        this.formulario = {
          codigo: this.normativa.codigo || '',
          titulo: this.normativa.titulo || '',
          descricao: this.normativa.descricao || '',
          ids_categorias: this.normativa.ids_categorias || [],
          arquivo_nome: this.normativa.arquivo_nome || '',
          arquivo_base64: this.normativa.arquivo_base64 || '',
          publica: this.normativa.publica || 'T',
          ids_grupos: this.normativa.ids_grupos || [],
          ids_usuarios: this.normativa.ids_usuarios || [],
          anexos: this.normativa.anexos ? [...this.normativa.anexos] : []
        }

        if (this.normativa.arquivo_base64 && this.normativa.arquivo_nome) {
          this.arquivoPrincipal = {
            nome: this.normativa.arquivo_nome,
            tamanho: this.calcularTamanhoBase64(this.normativa.arquivo_base64),
            base64: this.normativa.arquivo_base64,
            tipo: 'pdf'
          }
        }

        this.permissoes = {
          publica: this.formulario.publica,
          ids_grupos: this.formulario.ids_grupos,
          ids_usuarios: this.formulario.ids_usuarios
        }
      } else {
        this.resetFormulario()
      }

      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetValidation()
        }
      })
    },

    calcularTamanhoBase64(base64String) {
      if (!base64String) return 0

      const base64 = base64String.replace(/\s/g, '')
      let tamanho = (base64.length * 3) / 4
      const padding = (base64.match(/=/g) || []).length
      tamanho -= padding

      return Math.floor(tamanho)
    },

    resetFormulario() {
      this.formulario = {
        codigo: '',
        titulo: '',
        descricao: '',
        ids_categorias: [],
        arquivo_nome: '',
        arquivo_base64: '',
        publica: 'T',
        ids_grupos: [],
        ids_usuarios: [],
        anexos: []
      }

      this.permissoes = {
        publica: 'T',
        ids_grupos: [],
        ids_usuarios: []
      }

      this.arquivoPrincipal = null
    },

    validarNomeArquivoPrincipal(nomeArquivo) {
      if (!nomeArquivo) return false
      const nomeBase = nomeArquivo.replace(/\.pdf$/i, '')
      const regexValido = /^[a-zA-Z0-9\u00C0-\u00FF ,_-]+$/
      return regexValido.test(nomeBase)
    },

    validarNomeArquivo(nomeArquivo) {
      if (!nomeArquivo) return false
      const partes = nomeArquivo.split('.')
      if (partes.length < 2) return false
      const extensao = partes.pop().toLowerCase()
      const nomeBase = partes.join('.')
      const extensoesPermitidas = ['pdf', 'xlsx', 'xls', 'docx', 'doc']
      if (!extensoesPermitidas.includes(extensao)) return false
      const regexValido = /^[a-zA-Z0-9\u00C0-\u00FF _-]+$/
      return regexValido.test(nomeBase) && nomeBase.length >= 3
    },

    gerarNomeArquivoDoTitulo(titulo, extensao = 'pdf') {
      if (!titulo || !titulo.trim()) return ''
      let nomeArquivo = titulo.trim()
      nomeArquivo = nomeArquivo
          .replace(/[^\w\sÀ-ÿ-]/g, '')
          .replace(/\s+/g, ' ')
          .trim()
      return `${nomeArquivo}.${extensao}`
    },

    atualizarNomeArquivoAnexo(payload) {
      const { index, titulo, extensao } = payload
      if (this.formulario.anexos[index]) {
        const nomeArquivo = this.gerarNomeArquivoDoTitulo(titulo, extensao)
        this.formulario.anexos[index].arquivo_nome = nomeArquivo
      }
    },

    normalizarNomeArquivo() {
      if (!this.formulario.arquivo_nome) return
      let nomeNormalizado = this.formulario.arquivo_nome.trim()
      if (!nomeNormalizado.toLowerCase().endsWith('.pdf')) {
        nomeNormalizado += '.pdf'
      }
      nomeNormalizado = nomeNormalizado.replace(/[^\wÀ-ÿ ._-]/g, '')
      nomeNormalizado = nomeNormalizado.replace(/\s+/g, ' ')
      this.formulario.arquivo_nome = nomeNormalizado
      if (this.$refs.form) {
        this.$nextTick(() => {
          this.$refs.form.validate()
        })
      }
    },

    removerCategoria(idCategoria) {
      const index = this.formulario.ids_categorias.indexOf(idCategoria)
      if (index > -1) {
        this.formulario.ids_categorias.splice(index, 1)
      }
    },

    handleArquivoPrincipalChange(arquivo) {
      if (arquivo) {
        this.formulario.arquivo_base64 = arquivo.base64

        if (!this.modoEdicao && !this.formulario.arquivo_nome) {
          let nomeOriginal = arquivo.nome || 'normativa'
          nomeOriginal = nomeOriginal.replace(/\.pdf$/i, '')
          nomeOriginal = nomeOriginal.replace(/[^\wÀ-ÿ ,_-]/g, '')
          this.formulario.arquivo_nome = `${this.formulario.codigo} ${nomeOriginal}.pdf`
        }
      } else {
        this.formulario.arquivo_base64 = ''
      }
    },

    adicionarAnexo() {
      const identificador = this.gerarProximoIdentificador()
      this.formulario.anexos.push({
        identificador: identificador,
        titulo: '',
        arquivo_nome: '',
        arquivo_base64: '',
        arquivo_tipo: 'pdf',
        tamanho_bytes: 0
      })
    },

    removerAnexo(index) {
      this.formulario.anexos.splice(index, 1)
    },

    gerarProximoIdentificador() {
      if (this.formulario.anexos.length === 0) return 'A'
      const ultimoIdentificador = this.formulario.anexos[this.formulario.anexos.length - 1].identificador
      const proximaLetra = String.fromCharCode(ultimoIdentificador.charCodeAt(0) + 1)
      return proximaLetra
    },

    validarAnexos() {
      const erros = []

      for (let i = 0; i < this.formulario.anexos.length; i++) {
        const anexo = this.formulario.anexos[i]

        if (!anexo.identificador) {
          erros.push(`Anexo ${i + 1}: Identificador ausente`)
        }

        if (!anexo.titulo || !anexo.titulo.trim()) {
          erros.push(`Anexo ${anexo.identificador || i + 1}: Título é obrigatório`)
        }

        if (!anexo.arquivo_nome || !anexo.arquivo_nome.trim()) {
          erros.push(`Anexo ${anexo.identificador || i + 1}: Nome do arquivo ausente`)
        }

        if (!anexo.arquivo_tipo) {
          erros.push(`Anexo ${anexo.identificador || i + 1}: Tipo de arquivo ausente`)
        }

        if (!anexo.arquivo_base64) {
          erros.push(`Anexo ${anexo.identificador || i + 1}: Arquivo não foi enviado`)
        }

        if (anexo.arquivo_nome && !this.validarNomeArquivo(anexo.arquivo_nome)) {
          erros.push(`Anexo ${anexo.identificador || i + 1}: Nome do arquivo "${anexo.arquivo_nome}" contém caracteres inválidos`)
        }
      }

      if (erros.length > 0) {
        console.error('❌ Erros de validação nos anexos:', erros)
        this.mostrarSnackbar(erros[0], 'error')
        return false
      }

      return true
    },

    async salvar() {
      if (!this.$refs.form.validate()) {
        this.mostrarSnackbar('Por favor, preencha todos os campos obrigatórios', 'error')
        return
      }

      if (this.formulario.ids_categorias.length === 0) {
        this.mostrarSnackbar('Selecione pelo menos uma categoria', 'error')
        return
      }

      if (this.formulario.ids_categorias.length > 5) {
        this.mostrarSnackbar('Máximo de 5 categorias permitidas', 'error')
        return
      }

      if (!this.validarNomeArquivoPrincipal(this.formulario.arquivo_nome)) {
        this.mostrarSnackbar('Nome do arquivo principal inválido', 'error')
        return
      }

      if (!this.modoEdicao && !this.formulario.arquivo_base64) {
        this.mostrarSnackbar('Upload do arquivo principal é obrigatório', 'error')
        return
      }

      if (this.modoEdicao && !this.formulario.arquivo_base64 && !this.normativa.arquivo_base64) {
        this.mostrarSnackbar('Arquivo principal é obrigatório', 'error')
        return
      }

      if (!this.$refs.permissoes.validar()) {
        this.mostrarSnackbar('Normativas restritas devem ter pelo menos um grupo ou usuário selecionado', 'error')
        return
      }

      if (this.formulario.anexos.length > 0 && !this.validarAnexos()) {
        return
      }

      this.salvando = true

      try {
        const payload = {
          acao: this.modoEdicao ? 'atualizar' : 'criar',
          codigo: this.formulario.codigo.trim(),
          titulo: this.formulario.titulo.trim(),
          descricao: this.formulario.descricao?.trim() || '',
          ids_categorias: this.formulario.ids_categorias,
          arquivo_nome: this.formulario.arquivo_nome.trim(),
          publica: this.formulario.publica,
          ids_grupos: this.formulario.ids_grupos,
          ids_usuarios: this.formulario.ids_usuarios,
          anexos: this.formulario.anexos
        }

        if (this.formulario.arquivo_base64) {
          payload.arquivo_base64 = this.formulario.arquivo_base64
        }

        if (this.modoEdicao) {
          payload.id = this.normativa.id
        }

        const response = await axios.post(`${this.backendUrl}normativa`, payload)

        this.mostrarSnackbar(
            this.modoEdicao ? 'Normativa atualizada com sucesso!' : 'Normativa criada com sucesso!',
            'success'
        )

        this.$emit('salvo', response.data)

        setTimeout(() => {
          this.fechar()
        }, 500)

      } catch (error) {
        console.error('Erro ao salvar normativa:', error)
        const mensagemErro = error.response?.data?.erro || error.message || 'Erro ao salvar normativa'
        this.mostrarSnackbar(mensagemErro, 'error')
      } finally {
        this.salvando = false
      }
    },

    fechar() {
      if (!this.salvando) {
        this.dialogInterno = false
        this.$emit('fechar')
        setTimeout(() => {
          this.resetFormulario()
          if (this.$refs.form) {
            this.$refs.form.resetValidation()
          }
        }, 300)
      }
    },

    mostrarSnackbar(message, color) {
      this.snackbar.message = message
      this.snackbar.color = color
      this.snackbar.show = true
    }
  }
}
</script>

<style scoped>
.v-card {
  overflow: hidden;
}

.dialog-header {
  background: linear-gradient(135deg, #023449 0%, #034d6b 100%);
  color: white;
}

.icon-wrapper-small {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.dialog-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: white;
  line-height: 1.3;
}

.dialog-subtitle {
  font-size: 0.875rem;
  color: rgba(255, 255, 255, 0.9);
  margin-top: 2px;
}

.dialog-content {
  overflow-y: auto;
  overflow-x: hidden;
  font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.section-card {
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(2, 52, 73, 0.04);
}

.section-header {
  background-color: #fafafa;
}

.section-title {
  font-size: 1rem;
  font-weight: 700;
  color: #023449;
  letter-spacing: -0.01em;
}

.add-attachment-btn {
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0;
  border-radius: 8px;
}

.save-btn {
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0;
  border-radius: 8px;
  padding: 0 24px !important;
  height: 44px !important;
  color: white;
}

.dialog-actions {
  background-color: #fafafa;
}

.dialog-content::-webkit-scrollbar {
  width: 8px;
}

.dialog-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.dialog-content::-webkit-scrollbar-thumb {
  background: #bbb;
  border-radius: 4px;
}

.dialog-content::-webkit-scrollbar-thumb:hover {
  background: #999;
}

/* Mobile Styles */
@media (max-width: 959px) {
  .dialog-title {
    font-size: 1rem;
  }

  .dialog-subtitle {
    font-size: 0.75rem;
  }

  .section-title {
    font-size: 0.875rem;
  }

  .section-card {
    border-radius: 8px;
  }

  .save-btn {
    padding: 0 16px !important;
    height: 36px !important;
  }

  .icon-wrapper-small {
    padding: 6px;
    border-radius: 6px;
  }

  /* Reduz margem entre campos no mobile */
  .v-input {
    margin-bottom: 0 !important;
  }

  /* Ajusta espaçamento dos chips */
  ::v-deep .v-chip {
    margin: 2px !important;
  }

  /* Ajusta altura dos campos no mobile */
  ::v-deep .v-text-field.v-text-field--enclosed .v-text-field__details {
    margin-bottom: 4px;
  }
}

/* Tablets */
@media (max-width: 768px) and (min-width: 600px) {
  .dialog-title {
    font-size: 1.125rem;
  }
}

/* Accessibility */
@media (prefers-reduced-motion: reduce) {
  * {
    transition: none !important;
  }
}

/* Fix para overflow em v-select no mobile */
::v-deep .v-select__selections {
  flex-wrap: nowrap !important;
  overflow: hidden;
}

::v-deep .v-select__selection--comma {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>